// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--2J1pt","seo-block":"_93444fe79c--seo-block--N2mAK","title":"_93444fe79c--title--xzilx","link":"_93444fe79c--link--3_Nkd"};